import Wix from './wix-sdk-polyfill';
import { getI18nLanguage } from '@wix/communities-blog-client-common';

export default function requestLogin(cb) {
  return Wix.requestLogin(
    {
      language: getI18nLanguage(),
      checkCommunityCheckbox: true,
    },
    (member) => {
      if (member && member.authResponse) {
        member = member.data;
      }
      cb(member);
    },
  );
}
